import { fromAuthorisationResponses, toAuthorisationRequests } from '../models/mapper'
import { AuthorisationUpdate } from '../models/request'
import { Authorisation } from '../models/types'
import { createAuthorisationsV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createAuthorisations(updates: AuthorisationUpdate[]): Promise<Authorisation[]> {
  const responses = await createAuthorisationsV2(toAuthorisationRequests(updates))
  return fromAuthorisationResponses(responses)
}
